import { useEffect, useMemo, useState } from "react";
import { NavLink, useHistory, useLocation, useParams } from "react-router-dom"
import Loader, { hideLoader, showLoader } from "../components/loader";
import Step1 from "../components/walkthrough-steps/step1";
import Step2 from "../components/walkthrough-steps/step2";
import Step3 from "../components/walkthrough-steps/step3";
import Step4 from "../components/walkthrough-steps/step4";
import Step5 from "../components/walkthrough-steps/step5";
import Step6 from "../components/walkthrough-steps/step6";
import { Step7 } from "../components/walkthrough-steps/step7";
import { useDispatch, useSelector } from "react-redux"
import CroppieModal from "../components/croppie-modal";
import { zaapLogo } from "../utils/url";
import TagStep from "../components/walkthrough-steps/tag-step";
import BioStep from "../components/walkthrough-steps/bio-step";
import Signup from "./signup";
import CampaignStep from "../components/walkthrough-steps/campaign-step";

export function useQuery() {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
}


export const myHeaders = new Headers();
myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)

let croppie_image = { url: "", id: null };
const Walkthrough = () => {
    const { search, state } = useLocation();
    const history = useHistory()
    let query = useQuery();
    const dispatch = useDispatch()
    const [isStep3, setIsStep3] = useState(false)
    const [croppie, setCroppie] = useState(null);
    const walkthroughState = useSelector(state => state.walkthroughSteps);
    const [showCroppieModal, setshowCroppieModal] = useState(false)
    const currentStep = localStorage.getItem("currentStep");
    const lastStep = localStorage.getItem("lastStep");
    const [stepToShow, setStepToShow] = useState(null);
    const { basePath } = useSelector(state => state?.slugReducer);

    var moveNext = (e, param) => {
        e.preventDefault();
        setTimeout(() => {

            if (param !== "dashboard") {

                dispatch({ type: "SET_STEPS", payload: { ...walkthroughState, lastStep: +walkthroughState?.lastStep + +1, currentStep: +walkthroughState?.currentStep + +1 } });

                localStorage.setItem("lastStep", param - 1);
                localStorage.setItem("currentStep", param);
                history.push({
                    search: `step=${param}`,
                });
            }
            else {
                const slug = localStorage?.getItem("slug")
                // dispatch({ type: "SET_STEPS", payload: { walkthrough: 1 } });

                // if (basePath) {
                //     dispatch({ type: "SET_SLUG", payload: { slug: slug, basePath: "/project/" + slug, newChange: false } })
                //     history.push({
                //         pathname: `/${basePath}/page-editor`,
                //         state: { congratsOpen: "true" }
                //     })
                // }
                // else {
                //     dispatch({ type: "SET_SLUG", payload: { slug: slug, basePath: "/project/" + slug, newChange: false } })
                localStorage.removeItem("lastStep")
                localStorage.removeItem("currentStep")
                localStorage.removeItem("walkthrough_step")
                localStorage.setItem("walkthrough", 1)
                history.push({
                    pathname: `/project/${slug}/page-editor`,
                    state: { congratsOpen: "true" }
                });
                history.go()
                // }
                hideLoader()

                return
            }
            const search = new URLSearchParams(window.location.search);
            stepForward(search.get("step"))
            hideLoader()
        }, 500);
    }


    useEffect(() => {
        showLoader()
        const params = query.get("step");
        const setParams = new URLSearchParams(window.location.search);
        if (currentStep && lastStep) {
            // if (currentStep !== walkthroughState?.currentStep) {
            //     dispatch({ type: "SET_STEPS", payload: { lastStep: lastStep, currentStep: currentStep } })
            // }
            if (currentStep !== "null" && params !== "null") {

                if (params !== currentStep) {
                    history.replace({ search: `step=${currentStep}` });
                }
                stepForward(currentStep);
            }
            if (params !== currentStep) {
                if (currentStep && currentStep !== "null") {
                    // if (currentStep == 1) history.replace({ search: `step=${currentStep}` });

                    stepForward(currentStep);
                    history.replace({ search: `step=${currentStep}` });
                }
                else if (lastStep && lastStep !== "null") {
                    stepForward(lastStep);
                    history.replace({ search: `step=${lastStep}` });
                }
                else if (params && params !== "null") {
                    stepForward(params);

                    // console.log(103);
                    history.replace({ search: `step=${params}` });
                }
                else {
                    localStorage.setItem("currentStep", 1);
                    localStorage.setItem("lastStep", null);
                    setParams.set("step", 1);
                    stepForward(1);
                }
            }

            hideLoader();
        }
        return () => hideLoader();
    }, []);

    const moveBack = (e, response, value) => {
        localStorage.setItem("currentStep", (e.target.dataset.step));
        localStorage.setItem("lastStep", (e.target.dataset.step) - 1);
        dispatch({ type: "SET_STEPS", payload: { lastStep: (e.target.dataset.step) - 1, currentStep: (e.target.dataset.step) } })
        localStorage.setItem("backStepValue", JSON.stringify(response?.data))

        history.push({
            search: `step=${e.target.dataset.step}`,
        });
    };

    const stepForward = (params) => {
        if (params === "1") {
            setIsStep3(false)
            setStepToShow({
                component: <Step1 moveNext={moveNext} />,
                step: 1
            })
            hideLoader()
        }

        else if (params === "2") {
            setIsStep3(false)
            setStepToShow({
                component: <CampaignStep moveNext={moveNext} />,
                step: 2
            })
            // setStepToShow({
            //     component: <Step2 moveNext={moveNext} moveBack={moveBack} />,
            //     step: 2
            // })
            hideLoader()
        }

        else if (params === "3") {
            setIsStep3(true)
            setStepToShow({
                component: <TagStep moveNext={moveNext} moveBack={moveBack} />,
                step: 3
            })
            hideLoader()
        }

        else if (params === "4") {
            setIsStep3(false)
            setStepToShow({
                component: <BioStep moveNext={moveNext} moveBack={moveBack} />,
                step: 4
            })
            hideLoader()
        }

        // else if (params === "3") {
        //     setIsStep3(true)
        //     setStepToShow({
        //         component: <Step3 moveNext={moveNext} moveBack={moveBack} />,
        //         step: 3
        //     })
        //     hideLoader()
        // }

        // else if (params === "4") {
        //     setIsStep3(false)
        //     setStepToShow({
        //         component: <Step4 moveNext={moveNext} moveBack={moveBack} />,
        //         step: 4
        //     })
        //     hideLoader()
        // }

        else if (params === "5") {
            setIsStep3(false)
            setStepToShow({
                component: <Step3 moveNext={moveNext} moveBack={moveBack} />,
                step: 5
            })
            hideLoader()
        }
        else if (params === "6")
        {setIsStep3(false)
                setStepToShow({
                    component: <Step7 moveNext={moveNext} />,
                    step: 6
                })
                hideLoader()
            }
        // else if (params === "5") {
        //     setIsStep3(false)
        //     setStepToShow({
        //         component: <Step5 moveNext={moveNext} moveBack={moveBack} />,
        //         step: 5
        //     })
        //     hideLoader()
        // }

        // else if (params === "6") {
        //     setIsStep3(false)
        //     setStepToShow({
        //         component: <Step6 moveNext={moveNext} moveBack={moveBack} />,
        //         step: 6
        //     })
        //     hideLoader()
        // }
        else {
            // showLoader()
            setIsStep3(false);
            // showLoader()
            // history.push("/_404")
            hideLoader()
        }

    }
    const dropzoneChange = (e) => {
        $('#profile_pic_upload_modal').modal('hide');
        setTimeout(() => {

            setshowCroppieModal(true)
            generate_image_preview(e.target);
        }, [500])

    }

    const croppieClose = () => {

        setshowCroppieModal(false)
        setCroppie(null)
        croppie_image = { url: "", id: null };
        document.getElementById("image_demo2").innerHTML = null
        setTimeout(() => {

            $('#profile_pic_upload_modal').modal('show');
        }, 300);

    }

    function generate_image_preview(input) {

        if (input.files && input.files[0]) {
            let reader = new FileReader();
            //   alert(input.files[0].size);
            if (input.files[0].size >= 5242880) {
                $('#image_file_input').val('');
                let notification_container = $('.notification-container');

                // console.log("notification_container", notification_container)
                // display_notifications(['File Size Should not exceed 5MBs'], 'error', notification_container);
                return;
            }
            var val = input.files[0].name;
            // alert(val);
            var valid_extensions = ['png', 'jpg', 'jpeg'];
            var extension = val.substring(val.lastIndexOf('.') + 1, val.length) || val;
            if (!valid_extensions.includes(extension)) {
                $('#image_file_input').val('');
                let notification_container = $('.notification-container');

                // console.log("notification_container", notification_container)
                // display_notifications(['Invalid Image File. Should be png, jpg or jpeg'], 'error', notification_container);
                return;
            }
            reader.onload = event => {
                croppie_image = {
                    url: event.target.result,
                }

                // console.log("e.target", event)
                const el = document.getElementById("image_demo2")
                try {
                    if (el) {
                        var croppieInstance = new Croppie(el, {
                            enableExif: true,
                            viewport: {
                                width: 250,
                                height: 250,
                                type: 'circle' //circle
                            },
                            boundary: {
                                width: 300,
                                height: 300
                            }
                        });
                        croppieInstance.bind({
                            url: event.target.result,
                        }).then(function () {

                            // console.log('jQuery bind complete');
                        });
                        setCroppie(croppieInstance)
                    }
                } catch { }

            };
            reader.readAsDataURL(input.files[0]);
        }
    }
    const croppedImage = () => {
        showLoader()
        if (croppie !== null) {
            // return;
            croppie.result({
                type: "blob",
                size: "viewport",
                format: "png",
                quality: 1,
            }).then((response) => {
                dispatch({ type: "SET_UPLOAD_IMAGE", payload: { imageData: response } })
                var reader = new FileReader();
                reader.onload = function (e) {
                    $('#image_file_preview').attr('src', reader.result);
                    $('#image_file_preview_2').attr('src', reader.result);
                }
                reader.readAsDataURL(response);
                setshowCroppieModal(false)
                document.getElementById("image_demo2").innerHTML = null
                croppie_image = { url: "", id: null };
                setCroppie(null)
                hideLoader()
            }).catch((err) => {

                // console.log("err", err)
                croppie_image = { url: "", id: null };
                setCroppie(null);
                hideLoader()
            })
        }
        else {
            // croppie_image = { url: "", id: null };
            // setCroppie(null)
            // hideLoader()

        }

    };

    return (
        <>
            {
                stepToShow?.component ?
                    <>
                        <div id="wrapper">
                            {/* <NavLink to="/logout" className="walkthrough-logout semi-bold text-decoration-none">Logout</NavLink>
                            <nav id="navbar" class="ps-3 pt-2 navbar bavbar-main navbar-expand-lg navbar-light">
                                <div class="">
                                    <div class="p-lg-0 p-md-0 p-sm-2">
                                        <a class="navbar-brand" href="https://www.znaplink.com/">
                                            <img src={zaapLogo}
                                                class="img-fluid navbar-logo" alt="Website Logo" />
                                        </a>
                                    </div>
                                </div>
                            </nav> */}
                            <div class="auth-main background-area main-u">{stepToShow?.component}</div>
                            <input type="hidden" name="" className="profile_pic_upload_modal" data-bs-toggle="modal" data-bs-target="#profile_pic_upload_modal" />
                            <div class="zaap-logo-area">
                            <svg xmlns="http://www.w3.org/2000/svg" width="150" height="38" viewBox="0 0 150 38" fill="none">
                                <path d="M55.9433 25.5577C51.4081 25.5577 48.2148 22.2256 48.2148 17.0656C48.2148 12.16 51.3155 8.66602 56.3367 8.66602C60.5481 8.66602 63.4405 11.1651 64.1346 15.2607H61.2885C60.7794 12.7154 58.9052 11.1651 56.3367 11.1651C53.0972 11.1651 51.061 13.4327 51.061 17.0656C51.061 20.7447 53.1204 23.0355 56.221 23.0355C58.7432 23.0355 60.3861 21.3926 60.3861 19.0787H55.5037V16.7416H61.034C63.1165 16.7416 64.2503 17.7829 64.2503 19.7497V25.2106H61.7976V20.2588H61.7513C61.4273 23.4983 59.2985 25.5577 55.9433 25.5577Z" fill="#012125"/>
                                <path d="M72.5593 25.5577C68.8108 25.5577 66.2423 22.8735 66.2423 19.125C66.2423 15.0756 68.9033 12.5765 72.3279 12.5765C75.7988 12.5765 78.1127 15.0062 78.1821 18.9861V19.634H68.9727C69.1578 21.786 70.4999 23.2437 72.5824 23.2437C73.9939 23.2437 75.0583 22.5496 75.4749 21.3232H78.1359C77.5111 23.9611 75.4517 25.5577 72.5593 25.5577ZM69.0884 17.7135H75.3592C75.0121 15.9549 73.9245 14.8905 72.3279 14.8905C70.7082 14.8905 69.5049 15.9549 69.0884 17.7135Z" fill="#012125"/>
                                <path d="M83.0432 25.2106H80.3128V12.9468H82.511L82.7424 14.7516C83.506 13.479 85.0563 12.5765 86.8843 12.5765C89.499 12.5765 91.2113 14.3351 91.2113 17.0887V25.2106H88.4809V17.2275C88.4809 15.8623 87.5785 14.9599 86.0513 14.9599C84.2696 14.9599 83.0663 16.1863 83.0432 17.7829V25.2106Z" fill="#012125"/>
                                <path d="M97.5634 25.2106H94.7867V9.0131H103.001C106.31 9.0131 108.323 11.2113 108.323 14.1037C108.323 17.3664 106.056 19.3563 103.001 19.3563H97.5634V25.2106ZM97.5634 11.5121V16.8573H102.862C104.598 16.8573 105.5 15.5615 105.5 14.1037C105.5 12.5765 104.459 11.5121 102.862 11.5121H97.5634Z" fill="#012125"/>
                                <path d="M114.579 25.4651C111.756 25.4651 109.905 24.0999 109.928 21.8091C109.951 18.9398 112.797 18.3382 115.181 18.0605C117.032 17.8523 118.397 17.7829 118.42 16.811C118.397 15.6078 117.471 14.8211 115.898 14.8211C114.278 14.8211 113.121 15.7003 112.959 16.973H110.206C110.46 14.3814 112.774 12.5765 115.944 12.5765C119.253 12.5765 121.081 14.3814 121.081 16.9961V22.5496C121.081 22.8966 121.266 23.0818 121.683 23.0818H122.354V25.2106H121.058C119.809 25.2106 119.045 24.7015 118.837 23.7759C118.79 23.6602 118.744 23.4983 118.721 23.3594C118.004 24.6784 116.662 25.4651 114.579 25.4651ZM115.134 23.3132C117.009 23.3132 118.42 22.2487 118.42 20.6059V18.8936C117.957 19.6109 116.777 19.7728 115.482 19.9348C113.954 20.1199 112.682 20.3282 112.682 21.624C112.682 22.6884 113.538 23.3132 115.134 23.3132Z" fill="#012125"/>
                                <path d="M129.755 30.2086C126.331 30.2086 123.971 28.5426 123.971 25.9047H126.701C126.701 27.0617 127.927 27.9873 129.755 27.9873C131.93 27.9873 133.064 26.6915 133.064 24.8403V23.1049C132.278 24.285 130.912 25.0255 129.154 25.0255C125.868 25.0255 123.508 22.4801 123.508 18.8241C123.508 15.145 125.868 12.5765 129.131 12.5765C131.051 12.5765 132.601 13.479 133.365 14.8442L133.596 12.9468H135.772V24.8403C135.772 28.0798 133.481 30.2086 129.755 30.2086ZM129.686 22.7347C131.676 22.7347 133.064 21.1149 133.064 18.801C133.064 16.4871 131.676 14.8905 129.686 14.8905C127.696 14.8905 126.331 16.4871 126.331 18.8241C126.331 21.1381 127.696 22.7347 129.686 22.7347Z" fill="#012125"/>
                                <path d="M144.196 25.5577C140.448 25.5577 137.879 22.8735 137.879 19.125C137.879 15.0756 140.54 12.5765 143.965 12.5765C147.436 12.5765 149.75 15.0062 149.819 18.9861V19.634H140.61C140.795 21.786 142.137 23.2437 144.22 23.2437C145.631 23.2437 146.695 22.5496 147.112 21.3232H149.773C149.148 23.9611 147.089 25.5577 144.196 25.5577ZM140.726 17.7135H146.996C146.649 15.9549 145.562 14.8905 143.965 14.8905C142.345 14.8905 141.142 15.9549 140.726 17.7135Z" fill="#012125"/>
                                <path d="M14.8362 3.60963L7.64368 6.75637C5.39969 7.73812 3.94971 9.95516 3.94971 12.4045V21.0734C3.94971 24.6444 6.89481 27.2752 10.1676 27.2449L10.4846 30.3233C5.4606 30.531 0.867188 26.5354 0.867188 21.0734V12.4045C0.867188 8.73048 3.04216 5.40492 6.40815 3.9323L13.6007 0.785557C18.249 -1.24808 23.3226 0.856484 25.4838 4.91642H21.6874C19.985 3.2084 17.3196 2.52316 14.8362 3.60963Z" fill="#012125"/>
                                <path d="M17.4664 7.56454L11.3333 12.4656C9.41989 13.9947 8.59313 16.5115 9.22707 18.8774L11.4708 27.2509C12.0299 29.3379 13.5414 30.8133 15.3466 31.4592L16.192 34.8226C12.6928 34.3426 9.52095 31.8841 8.49327 28.0487L6.24959 19.6752C5.29868 16.1264 6.53882 12.3512 9.40897 10.0576L15.542 5.15647C20.5091 1.18715 27.8032 3.32236 29.9678 9.11263L26.5493 9.11263C24.6778 6.09658 20.4446 5.18453 17.4664 7.56454Z" fill="#012125"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M34.7751 16.4502C34.7751 12.0042 30.2121 9.02 26.139 10.802L18.9464 13.9488C16.7024 14.9305 15.2524 17.1475 15.2524 19.5969V28.2658C15.2524 32.6991 19.7915 35.6832 23.8615 33.9257L31.0541 30.8198C33.3125 29.8446 34.7751 27.62 34.7751 25.16V16.4502ZM24.9034 7.97794C31.0132 5.30492 37.8576 9.78127 37.8576 16.4502V25.16C37.8576 28.85 35.6638 32.1869 32.2761 33.6498L25.0835 36.7557C18.9786 39.3919 12.1699 34.9157 12.1699 28.2658V19.5969C12.1699 15.9229 14.3449 12.5973 17.7109 11.1247L24.9034 7.97794Z" fill="#012125"/>
                            </svg>
                            </div>
                        </div>
                        {/* {
                            isStep3 && (<div class="page-aside-bg page-aside-bg2"></div>)
                        } */}
                        <div class="modal fade" id="profile_pic_upload_modal" tabindex="-1" role="dialog" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                                <div class="modal-content">


                                    <div class="modal-header create-biolink-header">
                                        <h5 class="modal-title create-biolink-heading">Upload Image</h5>

                                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>


                                    <div class="modal-body">
                                        <section class="mt-2 mb-2">
                                            <form action="" method="POST" enctype="multipart/form-data">
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <div class="form-group mb-0">
                                                                <div class="preview-zone hidden">

                                                                </div>
                                                                <div class="dropzone-wrapper dropzone-wrapper1">
                                                                    <div class="dropzone-desc">

                                                                        <svg width="35" height="35" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <circle cx="22" cy="22" r="22" fill="#EBF5FF" />
                                                                            <path d="M29.5962 15.8218C30.1104 16.077 30.5697 16.4394 30.9462 16.8852C31.5643 17.6169 31.9347 18.5424 31.9921 19.5294L32 19.8V28.6C32 30.9564 30.2318 32.8802 28.0096 32.9946L27.8 33H15.2C12.9507 33 11.1144 31.1476 11.0051 28.8196L11 28.6V19.8C11 18.7123 11.3795 17.6835 12.0538 16.8852C12.3675 16.5137 12.7387 16.2001 13.1513 15.9583L13.4038 15.8218L14.3027 17.8101C14.0457 17.9376 13.8154 18.1193 13.6265 18.343C13.331 18.6929 13.1495 19.1284 13.1088 19.5972L13.1 19.8V28.6C13.1 29.7598 13.9566 30.71 15.0432 30.794L15.2 30.8H27.8C28.9071 30.8 29.8141 29.9025 29.8942 28.7642L29.9 28.6V19.8C29.9 19.2546 29.7112 18.7429 29.3735 18.343C29.2224 18.1641 29.0447 18.012 28.8481 17.893L28.6973 17.8101L29.5962 15.8218ZM21.5 11L21.5203 11.0002L21.562 11.0019C21.5743 11.0027 21.5867 11.0037 21.599 11.0049L21.6225 11.0074L21.6506 11.0113C21.6714 11.0145 21.6922 11.0183 21.7129 11.0227C21.7222 11.0246 21.7315 11.0268 21.7408 11.0291L21.774 11.0379L21.8065 11.0477C21.8136 11.0499 21.8207 11.0523 21.8277 11.0547C21.8484 11.0617 21.8691 11.0696 21.8896 11.0782C21.9082 11.086 21.9264 11.0942 21.9444 11.103C21.9661 11.1137 21.9875 11.1252 22.0085 11.1374C22.0212 11.1447 22.034 11.1525 22.0467 11.1606C22.0521 11.1642 22.0575 11.1677 22.0629 11.1713L22.1178 11.2104C22.1264 11.217 22.1351 11.2238 22.1436 11.2307C22.152 11.2377 22.1543 11.2397 22.1567 11.2417L22.2424 11.3222L26.4424 15.7222C26.8525 16.1518 26.8525 16.8482 26.4424 17.2778C26.0639 17.6744 25.4683 17.7049 25.0564 17.3693L24.9576 17.2778L22.55 14.7565V27.5C22.55 28.1075 22.0799 28.6 21.5 28.6C20.9615 28.6 20.5177 28.1754 20.457 27.6283L20.45 27.5V14.7554L18.0424 17.2778C17.6324 17.7074 16.9676 17.7074 16.5576 17.2778C16.179 16.8813 16.1499 16.2573 16.4702 15.8258L16.5576 15.7222L20.7576 11.3222L20.8433 11.2417C20.8457 11.2397 20.848 11.2377 20.8504 11.2357L20.7576 11.3222C20.7969 11.281 20.8386 11.2437 20.8822 11.2104C20.9054 11.1928 20.929 11.1762 20.9533 11.1607C20.966 11.1525 20.9788 11.1446 20.9917 11.1371C21.0125 11.1252 21.0339 11.1137 21.0557 11.103C21.0736 11.0943 21.0918 11.086 21.1101 11.0784C21.1308 11.0697 21.1516 11.0617 21.1727 11.0545C21.1794 11.0523 21.1864 11.0499 21.1935 11.0477L21.2262 11.0378C21.2371 11.0347 21.2481 11.0318 21.2592 11.0291L21.2871 11.0227C21.3078 11.0183 21.3286 11.0145 21.3494 11.0113C21.3584 11.0099 21.3679 11.0086 21.3775 11.0074L21.401 11.0049C21.4133 11.0037 21.4257 11.0027 21.438 11.0019L21.4799 11.0002C21.4866 11.0001 21.4933 11 21.5 11Z" fill="#53A4F6" />
                                                                        </svg>

                                                                        <p class="mb-1"><strong>Drag and drop files, or <a style={{ color: "#53A4F6" }}>Browse</a></strong></p>
                                                                        <small>5MB max file size upload</small>
                                                                    </div>
                                                                    <input type="file" accept=".png,.jpg,.jpeg" name="img_logo"
                                                                        class="dropzone dropzone1" onChange={dropzoneChange} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </form>
                                        </section>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </> :

                    <div class="full-page-loader">
                        <div class="lds-ripple"><div></div><div></div></div>
                    </div>

            }


            <CroppieModal show={showCroppieModal} handleHide={croppieClose} croppieClose={croppieClose} croppedImage={croppedImage} />


        </>
    )
}
export default Walkthrough